import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './IconDeprecated.module.css';
import '../../../libs/fontawesome6pro/css/all.min.css';
import '../../../libs/fontawesome6pro/css/light.min.css';
import '../../../libs/fontawesome6pro/css/regular.min.css';
import '../../../libs/fontawesome6pro/css/solid.min.css';
export enum IconSize {
  Small = 'small',
  Normal = 'normal',
  Large = 'large',
}
export enum IconType {
  Light = 'light',
  Regular = 'regular',
  Solid = 'solid',
}
export type IconProps = ComponentProps<'i'> & {
  size?: IconSize;
  type?: IconType;
  hasTextOnLeftSide?: boolean;
  hasTextOnRightSide?: boolean;
  /**
   * icon name without prefix, e.g. trash, times ...
   */
  name: string;
};

/**
 * @deprecated Please use the `Icon` component instead.
 */
export const IconDeprecated: FunctionComponent<IconProps> = React.memo(props => {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      className,
      hasTextOnLeftSide: t2,
      hasTextOnRightSide: t3,
      size: t4,
      type: t5,
      name,
      ...remainingProps
    } = prepareProps({
      props,
      ignoreChildren: true
    });
    const hasTextOnLeftSide = t2 === undefined ? false : t2;
    const hasTextOnRightSide = t3 === undefined ? false : t3;
    const size = t4 === undefined ? IconSize.Normal : t4;
    const type = t5 === undefined ? IconType.Regular : t5;
    t0 = remainingProps;
    t1 = classes(className, styles.general, iconSizeToClassName[size], iconTypeToClassName[type], `fa-${name}`, hasTextOnLeftSide ? styles.textOnLeftSide : undefined, hasTextOnRightSide ? styles.textOnRightSide : undefined);
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = <i {...t0} className={t1} />;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
});
const iconSizeToClassName: Record<IconSize, string> = {
  small: styles.sizeSmall,
  normal: styles.sizeNormal,
  large: styles.sizeLarge
};
const iconTypeToClassName: Record<IconType, string> = {
  regular: 'far',
  light: 'fal',
  solid: 'fas'
};